import React from 'react';
import classnames from 'classnames';
import { Icon } from 'tea-component';

import type { IBaseProps } from '@home/types/common';
import type { IUploadStatus } from '@gp/components/CoverUploader/types';

import './index.scss';

interface ICoverNameProps extends IBaseProps {
  status?: IUploadStatus;
  percents?: number;
  name?: string;
}

const ICON_STATUS = ['success', 'error'];

const CoverName: React.FC<ICoverNameProps> = (props) => {
  const { style, className, status, percents, name } = props;

  return (
    <div style={style} className={classnames('dbg-image-title', className)}>
      <h3 className="dbg-image-title__text">{name || '-'}</h3>
      {status === 'uploading' && (
        <div className="dbg-image-title-uploading">
          <Icon className="dbg-image-title-uploading-loading" type="loading" />
          {!Number.isNaN(percents) && <div className="dbg-image-title-uploading-text">{percents}%</div>}
        </div>
      )}
      {status && ICON_STATUS.includes(status) && <Icon type={status} />}
    </div>
  );
};

export default CoverName;
